module.exports = __webpack_public_path__ + "img/update-ai-button-hovered.9ac8b7ac.png";